export default class TimerChecker{
  constructor(initTime = 0, bOutputDom=false, bOutputConsole=false){
    this.initTime = initTime == 0 ? Date.now(): initTime;
    this.oldTime = this.initTime;
    this.bOutputDom = true;
    this.bOutputConsole = bOutputConsole;
  }

  check(label){
    const currentTime = Date.now();
    const diff = currentTime - this.oldTime;
    const total = currentTime - this.initTime;
    const infoText = `${label} : ${diff} ms. (total: ${total}) ms.`;
    // save current time for next diff
    this.oldTime = currentTime;

    // output logs
    if(this.bOutputConsole)
      console.log(infoText);

    if(this.bOutputDom){
      const node = document.createElement("P");
      const textNode = document.createTextNode(infoText);
      node.appendChild(textNode)
      document.getElementById("info").appendChild(node);
    }
  }
}
